import {
  ControlcenterMelcoModelsSupplier,
  SuppliersApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useManageSuppliers = (
  publishedState: string | undefined,
  supplierType?: string | undefined,
  customLimit?: number
) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQueryChange,
    searchQuery,
  } = useTable<ControlcenterMelcoModelsSupplier>({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    SuppliersApi,
    ["managesuppliers", searchQuery, currentPage, pageSize, filters, customLimit, sortBy()],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));

      let response = await api.supplierSearch({
        offset: (currentPage - 1) * pageSize,
        limit: customLimit ? customLimit : pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : "",

        publishState: publishedState ? publishedState : "",
        supplierType: supplierType ? supplierType : undefined,
      });

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: false,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQueryChange,
    errorComponent,
    searchQuery,
    ...query,
  };
};
